import helpers from '../helpers/methods'

const { firstAndLast, formatHour, capitalize, humanStorageSize, between, pad } = helpers

export default {
    firstAndLast, formatHour, capitalize, humanStorageSize, between, pad
}


// WEBPACK FOOTER //
// ./resources/assets/js/filters/methods.js